export default "__VITE_ASSET__RSU2pPaL__"